export default {
  ddoscdnInstance: {
    cname: 'CNAME',
    ddos_ips: '高防IP',
    bandwidth: '带宽 (Mbps)',
    defense_value: '防御值 (Gbps)',
    domain_num: '防御域名数',
    qps: '业务QPS',
    duration: '有效期',
    price: '价格',
    status: '状态',
    operation: '操作',
  }

}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/ddoscdn/instance.js